import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class StringUtilsService {
    constructor() {}

    trim(str) {
        return str.replace(/(^\s+|\s+)$/gm, "");
    }

    roundNoToTwoDecimal(num) {
        return parseFloat((Math.round(num * 100) / 100).toFixed(2));
    }

    formatNumberAsCurrency(num) {
        if (num === "#NA") {
            return num;
        }
        num = (Math.round(num * 100) / 100).toFixed(2);
        const formatNum = (numToFormat) =>
            numToFormat.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
        const numStr = num.toString().split(".");
        return numStr.length > 1
            ? `${formatNum(numStr[0])}.${numStr[1]}`
            : `${formatNum(numStr[0])}.00`;
    }

    getEllipsisText(str, len = 20) {
        let retStr = str || "";
        if (retStr.length > len) {
            retStr = `${retStr.substring(0, len - 3)}...`;
        }
        return retStr;
    }

    replaceAllSpace(str) {
        return str.replace(new RegExp("[^a-zA-Z0-9]", "g"), "");
    }

    getTitleCase(val) {
        return `${val.substr(0, 1).toUpperCase()}${val
            .substr(1, val.length - 1)
            .toLowerCase()}`;
    }
}
